module.exports = __webpack_public_path__ + "static/img/sdjzf.bdd9420.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sdjzf.jpg
// module id = WraG
// module chunks = 16